import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Restores window scroll position to the top whenever the route changes.
 * Hash-based scrolling (e.g. /#contact) is handled inside HomePage.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let HomePage handle hash anchors
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};
